import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=31f8087a"
import script from "./blank.vue?vue&type=script&lang=js"
export * from "./blank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31f8087a')) {
      api.createRecord('31f8087a', component.options)
    } else {
      api.reload('31f8087a', component.options)
    }
    module.hot.accept("./blank.vue?vue&type=template&id=31f8087a", function () {
      api.rerender('31f8087a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/homeNew/blank.vue"
export default component.exports